




















































































































import { Component, Vue, Prop } from 'vue-property-decorator';

import CloseIcon from '@/components/icons/Close.vue';
import BackButton from '@/componentsV2/molecules/BackButton/BackButton.vue';
import QuestionCircleIcon from '@/components/icons/QuestionCircle.vue';
import InfoIcon from '@/components/icons/Info.vue';

import Breadcrumbs, { BreadcrumbData } from '../Breadcrumbs/Breadcrumbs.vue';
import { IEducationPlayerProps } from '../EducationPlayer/EducationPlayer';
import EducationButton from '@/components/atoms/EducationButton/EducationButton.vue';
import LaunchRewardsProgramEmptyState from '@/componentsV2/organisms/LaunchRewardsProgramEmptyState/LaunchRewardsProgramEmptyState.vue';
import ProviderFeatureEmptyState from '@/componentsV2/organisms/ProviderFeatureEmptyState/ProviderFeatureEmptyState.vue';
import BannerActivateWidget from '@/components/molecules/BannerActivateWidget/BannerActivateWidget.vue';

import { needLaunchRewardsProgram } from '@/utils/start-guide';
import { needProviderConnected } from '@/utils/provider';
import BannerActivateOnlineInStore from '@/components/molecules/BannerActivateOnlineInStore/BannerActivateOnlineInStore.vue';
import BannerActivateRewards from '@/components/molecules/BannerActivateRewards/BannerActivateRewards.vue';
import BannerActivateBilling from '@/components/molecules/BannerActivateBilling/BannerActivateBilling.vue';
import { getCurrentGroup } from '@/router';
import {
  getIsRewardActivated,
  isFeatureAllowsNotHaveReward
} from '@/utils/rewards';
import flagKeys from '@/constants/flagKeys';
import { EBillingStatusTypes } from '@/store/modules/businessTypes';
import BillingNetworkTag from '@/componentsV2/atoms/BillingNetworkTag/BillingNetworkTag.vue';
import { IBusinessType } from '@/models/business';
import BannerReactiveBilling from '@/components/molecules/BannerReactiveBilling/BannerReactiveBilling.vue';
import { appIsActive, widgetIsEnabled } from '@/router/validators/utils';
import BillingModel from '@/views/Models/BillingModel.vue';
import { isRemoteLoading } from '@/utils/remote-loading';
import { getBillingIsHidden } from '@/utils/billing';

type Config = {
  descriptionMaxWidth?: string;
  background?: string;
  noPadding: boolean;
  headingsMarginBottom?: string;
  showCloseButton?: boolean;
  showTitleQuestion?: boolean;
  showBackButton?: boolean;
  breadcrumbGATitle?: string;
  titleTooltip?: string;
  educationVideo?: IEducationPlayerProps;
  needsWidget?: boolean;
  widgetHasToBeOnlineOnly?: boolean;
  isEmptyState?: boolean;
  loadPageEmptyState?: boolean;
  loading?: boolean;
  needsActivedRewards?: boolean;
  needsActivedBilling?: boolean;
};

function defaultConfig(): Config {
  return {
    background: 'var(--background-system)',
    noPadding: false,
    descriptionMaxWidth: '100%',
    headingsMarginBottom: '0',
    showCloseButton: false,
    showBackButton: false,
    showTitleQuestion: false,
    titleTooltip: '',
    isEmptyState: true
  };
}

@Component({
  components: {
    Breadcrumbs,
    CloseIcon,
    BackButton,
    QuestionCircleIcon,
    InfoIcon,
    EducationButton,
    LaunchRewardsProgramEmptyState,
    BannerActivateWidget,
    ProviderFeatureEmptyState,
    BannerActivateOnlineInStore,
    BannerActivateRewards,
    BannerActivateBilling,
    BannerReactiveBilling,
    BillingNetworkTag
  }
})
export default class Page extends BillingModel {
  @Prop({ default: () => Object.assign({}, defaultConfig()) }) config?: Config;
  @Prop() title?: string;
  @Prop() description?: string;
  @Prop() breadcrumbs?: BreadcrumbData[];

  resizeObserver!: ResizeObserver;

  data() {
    return {
      resizeObserver: null
    };
  }

  mounted() {
    const element = this.$refs.pageRemotingRootRef;

    this.resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        const { width, height } = entry.contentRect;
        window.parent.postMessage(
          {
            type: 'iframe:resize',
            data: { height }
          },
          '*'
        );
      }
    });

    if (element) {
      const height = (this.$refs.pageRemotingRootRef as any).scrollHeight;
      window.parent.postMessage(
        {
          type: 'iframe:resize',
          data: { height }
        },
        '*'
      );

      this.resizeObserver.observe(element as any);
    }
  }

  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  get isRemoteLoading() {
    return isRemoteLoading();
  }

  get configOptions() {
    return {
      ...defaultConfig(),
      ...this.config
    };
  }

  get needRewardsProgramEmptyState() {
    return needLaunchRewardsProgram(true);
  }

  get hasEmptyState() {
    return this.needRewardsProgramEmptyState || this.needProviderEmptyState;
  }

  get business() {
    return this.$store.getters['business/getBusinessInfo'].business || {};
  }

  get allowRewardAccess() {
    return (
      this.business.type === IBusinessType.INSTORE &&
      this.$route &&
      this.$route.meta &&
      this.$route.meta.$group &&
      this.$route.meta.$group.id !== 'loyalty-program'
    );
  }

  get isOnlineOnly() {
    return this.business.type === IBusinessType.ONLINE;
  }

  get widgetDeactivated() {
    return (
      !widgetIsEnabled() &&
      this.flags.includes(flagKeys.widgetDeactivationAlerts) &&
      (!appIsActive() ||
        (this.isOnlineOnly || !this.configOptions.widgetHasToBeOnlineOnly))
    );
  }

  get featureName() {
    if (this.$route.meta && this.$route.meta.$group)
      return this.$route.meta.$group.name;
    return this.title;
  }

  get showBannerWidget() {
    return (
      this.configOptions.needsWidget &&
      !this.hasEmptyState &&
      !this.configOptions.loading &&
      this.rewardsActive &&
      !this.inactiveBilling &&
      this.widgetDeactivated
    );
  }

  get showReactiveBillingBanner() {
    return (
      this.toBeCanceledBilling &&
      this.configOptions.needsActivedBilling &&
      !this.showBannerWidget &&
      !this.showBannerRewards &&
      !this.hasEmptyState &&
      !this.configOptions.loading
    );
  }

  get showBannerRewards() {
    return (
      this.configOptions.needsActivedRewards &&
      !this.configOptions.loading &&
      !this.hasEmptyState &&
      !this.inactiveBilling &&
      !this.rewardsActive
    );
  }

  get showActivateBillingBanner() {
    return (
      this.configOptions.needsActivedBilling &&
      !this.configOptions.loading &&
      !this.hasEmptyState &&
      this.inactiveBilling &&
      !this.configOptions.isEmptyState
    );
  }

  get rewardsActive() {
    if (isFeatureAllowsNotHaveReward() || this.allowRewardAccess) return true;
    return getIsRewardActivated();
  }

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get pageTitle() {
    return this.title;
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get showBillingTag() {
    if (
      !this.flags.includes(flagKeys.billingModuleV2) ||
      !this.business.coinNetworkSignup
    )
      return false;

    return (
      this.billingStatus !== EBillingStatusTypes.UNAVAILABLE &&
      !this.configOptions.isEmptyState &&
      this.configOptions.needsActivedBilling &&
      !this.configOptions.loading &&
      !this.hasEmptyState
    );
  }

  // Duplicated verbatim in ContentContainer, both Sell Coins screens and Purchase
  // History, so the hidden guard has to be repeated in each (TWISM-19008).
  get toBeCanceledBilling() {
    if (getBillingIsHidden()) return false;
    if (!this.flags.includes(flagKeys.billingModuleV2)) return false;

    return this.billingStatus === EBillingStatusTypes.TO_BE_CANCELED;
  }

  get welcomeCtaText() {
    const routeName =
      this.$route &&
      this.$route.meta &&
      this.$route.meta.navbar &&
      this.$route.meta.navbar.name;

    return `Explore ${this.title || routeName}`;
  }

  get enableHeadingsContainer() {
    return !!this.breadcrumbs || this.pageTitle || this.description;
  }

  get wrapperStyle() {
    return {
      background: this.configOptions.background
    };
  }

  get descriptionStyle() {
    return {
      width: this.configOptions.descriptionMaxWidth
    };
  }

  get headingsContainerStyle() {
    return {
      marginBottom: this.configOptions.headingsMarginBottom
    };
  }

  get needProviderEmptyState() {
    return (
      needProviderConnected(this.$route as any) &&
      this.configOptions.isEmptyState &&
      !this.configOptions.loading &&
      (this.isBillingModuleV4 ? !this.inactiveBilling : true)
    );
  }

  get showBannerActivateOnlineInStore() {
    return getCurrentGroup().id === 'loyalty-program';
  }
}
